// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2c366e0d","476":"fafdac29","634":"72037cbc"}[chunkId] + ".chunk.js";
};